import { createBrowserRouter } from 'react-router-dom';
import { RequireAuth } from './auth/RequireAuth';
import { Layout } from './routes/Layout';
import { LoginPage } from './routes/login/LoginPage';
import { TenantsPage } from './routes/tenants/TenantsPage';
import { TenantDetailPage } from './routes/tenants/TenantDetailPage';
import { PropertiesPage } from './routes/properties/PropertiesPage';
import { PropertyDetailPage } from './routes/properties/PropertyDetailPage';
import { AuditLogPage } from './routes/audit-log/AuditLogPage';
import { DomainEventsPage } from './routes/domain-events/DomainEventsPage';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    element: <RequireAuth />,
    children: [
      {
        element: <Layout />,
        children: [
          { path: '/', element: <TenantsPage /> },
          { path: '/tenants/:tenantId', element: <TenantDetailPage /> },
          { path: '/properties', element: <PropertiesPage /> },
          { path: '/properties/:propertyId', element: <PropertyDetailPage /> },
          { path: '/audit-log', element: <AuditLogPage /> },
          { path: '/domain-events', element: <DomainEventsPage /> },
        ],
      },
    ],
  },
]);
